/* eslint-disable max-lines-per-function */
import {
  type Layer,
  type StandardChartLayerSpec,
  defineStandardChartLayer
} from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';

const tag1 =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI4M18xMDk4OCkiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMjkyOTIgMEM0LjE4ODM1IDAgMy4yOTI5MiAwLjg5NTQzMSAzLjI5MjkyIDJWMTJMMC4xNDY0NzIgMTUuMTQ2NEMtMC4xNjg1MSAxNS40NjE0IDAuMDU0NTczNCAxNiAwLjUwMDAyNiAxNkgzLjI5MjkySDE3LjI5MjlDMTguMzk3NSAxNiAxOS4yOTI5IDE1LjEwNDYgMTkuMjkyOSAxNFYyQzE5LjI5MjkgMC44OTU0MzEgMTguMzk3NSAwIDE3LjI5MjkgMEg1LjI5MjkyWiIgZmlsbD0iI0ZGMjQzNiIvPgo8cGF0aCBkPSJNMTEuNTc2OSAzLjQzMjAxSDEyLjYzMjlWMTJIMTEuMjI4OVY1LjEyNDAxQzEwLjcxMjkgNS41OTIwMSAxMC4wNjQ5IDUuOTQwMDEgOS4yNzI5NSA2LjE2ODAxVjQuNzc2MDFDOS42NTY5NSA0LjY4MDAxIDEwLjA2NDkgNC41MTIwMSAxMC40OTY5IDQuMjcyMDFDMTAuOTI4OSA0LjAwODAxIDExLjI4ODkgMy43MzIwMSAxMS41NzY5IDMuNDMyMDFaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI4M18xMDk4OCI+CjxyZWN0IHdpZHRoPSIxOS4yOTI5IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=';
const tag2 =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI4M18xMDk5MykiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMjkyOTIgMEM0LjE4ODM1IDAgMy4yOTI5MiAwLjg5NTQzMSAzLjI5MjkyIDJWMTJMMC4xNDY0NzIgMTUuMTQ2NEMtMC4xNjg1MSAxNS40NjE0IDAuMDU0NTczNCAxNiAwLjUwMDAyNiAxNkgzLjI5MjkySDE3LjI5MjlDMTguMzk3NSAxNiAxOS4yOTI5IDE1LjEwNDYgMTkuMjkyOSAxNFYyQzE5LjI5MjkgMC44OTU0MzEgMTguMzk3NSAwIDE3LjI5MjkgMEg1LjI5MjkyWiIgZmlsbD0iI0ZGNUQwRCIvPgo8cGF0aCBkPSJNMTEuNTI0OCAzLjI2NDAxQzEyLjM1MjggMy4yNjQwMSAxMy4wMzY4IDMuNTA0MDEgMTMuNTc2OCAzLjk4NDAxQzE0LjEwNDggNC40NjQwMSAxNC4zNjg4IDUuMDc2MDEgMTQuMzY4OCA1Ljg0NDAxQzE0LjM2ODggNi41ODgwMSAxNC4wODA4IDcuMjYwMDEgMTMuNTI4OCA3Ljg3MjAxQzEzLjE5MjggOC4yMzIwMSAxMi41OTI4IDguNjg4MDEgMTEuNzUyOCA5LjI1MjAxQzEwLjg3NjggOS44MjgwMSAxMC4zNDg4IDEwLjMzMiAxMC4xNTY4IDEwLjc2NEgxNC4zODA4VjEySDguNDA0NzlDOC40MDQ3OSAxMS4xMjQgOC42ODA3OSAxMC4zNjggOS4yNTY3OSA5LjcyMDAxQzkuNTY4NzkgOS4zNjAwMSAxMC4yMjg4IDguODMyMDEgMTEuMjI0OCA4LjE0ODAxQzExLjc3NjggNy43NjQwMSAxMi4xNjA4IDcuNDQwMDEgMTIuNDAwOCA3LjE4ODAxQzEyLjc3MjggNi43NjgwMSAxMi45NjQ4IDYuMzEyMDEgMTIuOTY0OCA1LjgzMjAxQzEyLjk2NDggNS4zNjQwMSAxMi44MzI4IDUuMDE2MDEgMTIuNTkyOCA0Ljc4ODAxQzEyLjM0MDggNC41NjAwMSAxMS45Njg4IDQuNDUyMDEgMTEuNDc2OCA0LjQ1MjAxQzEwLjk0ODggNC40NTIwMSAxMC41NTI4IDQuNjMyMDEgMTAuMjg4OCA0Ljk5MjAxQzEwLjAyNDggNS4zMjgwMSA5Ljg4MDc5IDUuODQ0MDEgOS44NTY3OSA2LjUxNjAxSDguNDUyNzlDOC40NjQ3OSA1LjU1NjAxIDguNzQwNzkgNC43ODgwMSA5LjI5Mjc5IDQuMjAwMDFDOS44NTY3OSAzLjU3NjAxIDEwLjYwMDggMy4yNjQwMSAxMS41MjQ4IDMuMjY0MDFaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI4M18xMDk5MyI+CjxyZWN0IHdpZHRoPSIxOS4yOTI5IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=';
const tag3 =
  'data:image/svg+xml;base64,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';

const tagArray = [tag1, tag2, tag3];

const visInfo: Layer['visInfo'] = {
  id: 'wordCloud',
  name_en: 'wordCloud',
  name_zh: '词云',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    x: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    y: {
      itemType: [DEFINE.NUMBER],
      category: DEFINE.SINGLE
    }
  }
};

export interface Spec extends StandardChartLayerSpec {
  /** 使用的数据集索引，默认为 0 */
  dataIndex?: number;
  encoding: {
    x: string;
    y: string;
  };
  // 是否显示排名上标
  ranking: boolean;
  dvTextColors?: string[];
  // 字体大小范围
  dvFontSizeRange?: [number, number];
  // 字体粗细范围
  dvFontWeightRange?: [number, number];
  customClickEvent?: (data: CustomEvent) => void;
  customHoverEvent?: (data: CustomEvent) => void;
}

function handleMouseOver(params, customEvent, chartIns, option) {
  if (params.componentType === 'graphic') {
    const graphicId = params.id;

    option.graphic.forEach(graphic => {
      if (graphic.id !== graphicId) {
        graphic.style.opacity = 0.2;
      } else {
        graphic.style.opacity = 1;
      }
    });

    chartIns.play({ option });
  } else {
    if (customEvent) {
      customEvent({
        name: params.value[0],
        value: params.value,
        data: params
      });
    }
    option.graphic.forEach(graphic => {
      if (params.dataIndex == graphic.info.id) {
        graphic.style.opacity = 1;
      } else {
        graphic.style.opacity = 0.2;
      }
    });
    chartIns.play({ option });
  }
}

function handleSelect(event, customEvent, transformData, x) {
  const { dataIndexInside } = event;
  if (customEvent) {
    customEvent({
      data: [
        {
          dataIndex: dataIndexInside,
          key: x,
          value: transformData[dataIndexInside][x]
        }
      ],
      selectedType: 'value',
      selectedValue: transformData[dataIndexInside][x]
    });
  }
}

function handleAfterUpdate(chartIns, option) {
  const ecIns = chartIns.getECharts();
  const { _symbolDraw } = ecIns._chartsViews[0];
  const topThreePos = _symbolDraw._data._itemLayouts.slice(0, 3);
  const topThreeSize = [];

  if (_symbolDraw._data._itemVisuals.length === 0) {
    return;
  }
  for (let i = 0; i < 3; i++) {
    topThreeSize.push(_symbolDraw._data._itemVisuals[i].symbolSize);
  }

  const graphicZLevel = 1000;
  const iconSize = 20;
  const iconHeight = 16;
  option.graphic = [
    {
      type: 'image',
      left: topThreePos[0][0] + topThreeSize[0][0] / 2 - iconSize,
      top: topThreePos[0][1] - topThreeSize[0][1] / 2,
      style: { image: tag1, width: iconSize, height: iconHeight },
      z: graphicZLevel,
      info: {
        id: 0,
        name: 'icon0'
      }
    },
    {
      type: 'image',
      left: topThreePos[1][0] + topThreeSize[1][0] / 2 - iconSize,
      top: topThreePos[1][1] - topThreeSize[1][1] / 2,
      style: { image: tag2, width: iconSize, height: iconHeight },
      z: graphicZLevel,
      info: {
        id: 1,
        name: 'icon1'
      }
    },
    {
      type: 'image',
      left: topThreePos[2][0] + topThreeSize[2][0] / 2 - iconSize,
      top: topThreePos[2][1] - topThreeSize[2][1] / 2,
      style: { image: tag3, width: iconSize, height: iconHeight },
      z: graphicZLevel,
      info: {
        id: 2,
        name: 'icon2'
      }
    }
  ];
  chartIns.play({ option });
}

function handleMouseOut(params, chartIns, option) {
  option.graphic.forEach(graphic => {
    graphic.style.opacity = 1;
  });
  chartIns.play({ option });
}

function transformDataAndGenerateWordData(
  data: any[],
  y: string,
  x: string,
  colors: string[],
  util
): any[] {
  const transformData = util.dataTransform.transform(data.slice(), [
    { type: 'sort', field: y, order: 'descending' }
  ]);
  // 计算得到最大值作为基准值
  const maxValue = transformData[0][y];

  const wordData = [];
  (transformData as { [key: string]: string }[]).forEach((item, index) => {
    const currentValue = (Number(item[y]) / maxValue) * 100;
    let currentColor;
    let currentLevel;
    if (currentValue === 100) {
      [currentColor] = colors;
      currentLevel = 0;
    } else if (currentValue >= 80) {
      [, currentColor] = colors;
      currentLevel = 1;
    } else if (currentValue >= 60) {
      [, , currentColor] = colors;
      currentLevel = 2;
    } else if (currentValue >= 40) {
      [, , , currentColor] = colors;
      currentLevel = 3;
    } else if (currentValue >= 20) {
      [, , , , currentColor] = colors;
      currentLevel = 4;
    } else if (currentValue > 0) {
      [, , , , , currentColor] = colors;
      currentLevel = 5;
    } else {
      [, , , , , , currentColor] = colors;
      currentLevel = 6;
    }
    const current_wrd_data = {
      value: [item[x], currentValue],
      label: {
        color: currentColor
      },
      level: currentLevel
    };
    wordData.push(current_wrd_data);
  });

  return wordData;
}

export const layer = defineStandardChartLayer<Spec>({
  type: visInfo.id,
  isIndependentLayer: true,
  visInfo,
  render(api, spec, $dom) {
    const { data: dataArray, token, util, hook } = api;
    const {
      dataIndex = 0,
      encoding: { x, y },
      ranking,
      dvTextColors = ['#090E18', '#313A4F', '#4D576F', '#848D9F', '#9EA8B5', '#A9B2BE', '#A9B2BE'],
      dvFontSizeRange = [12, 32],
      dvFontWeightRange = [400, 600],
      customClickEvent,
      customHoverEvent
    } = spec;
    const presetOption = hook.buildStandardChartPresetOption(api);
    // 如果没有传入颜色，则使用默认颜色
    let colors;
    if (
      token.dvStandardChart?.baseOption.series.find(item => item.type === 'wordCloud')?.dvTextColors
    ) {
      colors = token.dvStandardChart.baseOption.series.find(item => item.type === 'wordCloud')
        ?.dvTextColors;
    } else {
      colors = dvTextColors;
    }

    const data = dataArray[dataIndex].values;
    const dataMetaInfo = hook.parseDataMetaInfo(data);
    const emphasisColor = colors[0];
    const sizes = [32, 28, 24, 20, 16, 14, 12];
    const weights = [600, 600, 600, 600, 600, 600, 400];
    const customFontSizeScale = params => {
      return sizes[params.level];
    };
    const customFontWeightScale = params => {
      return weights[params.level];
    };
    const blurStyle = {
      label: {
        formatter: params => {
          if (params.value[1] === 100) {
            return `{a|${params.value[0]}}`;
          }
          if (params.value[1] >= 80) {
            return `{b|${params.value[0]}}`;
          }
          if (params.value[1] >= 60) {
            return `{c|${params.value[0]}}`;
          }
          if (params.value[1] >= 40) {
            return `{d|${params.value[0]}}`;
          }
          if (params.value[1] >= 20) {
            return `{e|${params.value[0]}}`;
          }
          if (params.value[1] > 0) {
            return `{f|${params.value[0]}}`;
          }
          return `{g|${params.value[0]}}`;
        },
        rich: {
          a: {
            opacity: 0.5
          },
          b: {
            opacity: 0.5
          },
          c: {
            opacity: 0.6
          },
          d: {
            opacity: 0.7
          },
          e: {
            opacity: 1
          },
          f: {
            opacity: 1
          },
          g: {
            opacity: 1
          }
        }
      }
    };

    const transformData = util.dataTransform.transform(data.slice(), [
      { type: 'sort', field: y, order: 'descending' }
    ]);
    const wordData = transformDataAndGenerateWordData(data, y, x, colors, util);

    // * -------------------------- Chart
    const legend = {
      data: []
    };
    const option = {
      legend,
      xAxis: [],
      yAxis: [],
      dataZoom: [],
      animation: false,
      tooltip: {
        // ...presetOption?.tooltip,
        formatter: params_ => {
          const { name, value, seriesName } = params_;
          const items = [
            {
              name: y,
              value: `${
                hook.formatDataNumberValue(value[1], {
                  type: 'table',
                  unit: dataMetaInfo[seriesName]?.unit
                }).value
              }`
            }
          ];
          return hook.buildTooltip({
            config: hook.buildStandardChartPresetOption(api).tooltip,
            title: name || '',
            items
          });
        }
      },
      series: [
        {
          type: 'wordCloud',
          label: {
            show: true,
            formatter: '{@[0]}',
            color: '#000',
            fontFamily: 'Microsoft YaHei'
          },
          data: wordData,
          fontSizeScale: customFontSizeScale || 1,
          fontWeightScale: customFontWeightScale || 1,
          fontSizeRange: dvFontSizeRange,
          fontWeightRange: dvFontWeightRange,
          layout: {
            isLayoutByText: true,
            overlapAreaThreshold: 0,
            padding: 5,
            margin: 1
          },
          itemStyle: {
            color: 'transparent'
          },
          emphasis: {
            focus: 'self',
            label: {
              show: true,
              color: emphasisColor || '#000'
            }
          },
          blur: blurStyle
        }
      ],
      graphic: []
    };

    option.series[0].data = ThsDataVStandardChart.helper.wordCloudHelper.getFormatData(
      option.series[0]
    );
    // 对数据进行大小排序
    option.series[0].data.sort((a, b) => b.value[1] - a.value[1]);
    const markedDataLength = option.series[0].data.length > 3 ? 3 : option.series[0].data.length;
    for (let i = 0; i < markedDataLength; i += 1) {
      option.series[0].data[i].value.push({
        type: 'image',
        id: `icon${i}`,
        style: { image: tagArray[i], width: 36, height: 16 }
      });
    }
    return renderApi => {
      let redrawTrigger = true;
      const renderParams = {
        option: renderApi.mergeChartOptionProxy(option)
      };

      renderApi.renderLegendProxy(legend.data);
      const chartIns = renderApi.renderChartProxy(renderParams);

      if (ranking) {
        chartIns.on('dv:afterupdate', () => {
          window.chartIns = chartIns;
          if (redrawTrigger) {
            redrawTrigger = false;
            handleAfterUpdate(chartIns, renderParams.option);
          }
        });
      }

      chartIns.on('select', event => {
        handleSelect(event, customClickEvent, transformData, x);
      });
      // 鼠标移入事件触发
      chartIns.on('mouseover', params => {
        handleMouseOver(params, customHoverEvent, chartIns, renderParams.option);
      });
      // 鼠标移出事件触发
      chartIns.on('mouseout', params => {
        handleMouseOut(params, chartIns, renderParams.option);
      });
    };
  }
});
